var map = {
	"./Warehouse.png": 2744,
	"./apartment.png": 1945,
	"./bungalow.png": 1808,
	"./cabin.png": 8385,
	"./farmhouse.png": 3654,
	"./hotel.png": 3277,
	"./house.png": 4146,
	"./room.png": 7635,
	"./village.png": 6033
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8285;